function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var NODE_KEYS = {
  NODE_LEVEL_KEY: Symbol('__virtualized-tree-node-level__'),
  NODE_LOADER_KEY: Symbol('__virtualized-tree-node-loader__'),
  NODE_ERROR_KEY: Symbol('__virtualized-tree-node-error__'),
  NODE_SEPARATOR_KEY: Symbol('__virtualized-tree-node-separator__'),
  NODE_ACTION_TYPE: Symbol('__virtualized-tree-action-type__')
};
export var hasChildren = function hasChildren(children) {
  return Array.isArray(children) && children.length > 0;
};
export var cloneArray = function cloneArray(array) {
  if (!Array.isArray(array)) return [];
  return [].concat(array);
};
var keyMap = new Map();
var saveKeyCount = function saveKeyCount(node, valueKey) {
  if (valueKey === NODE_KEYS.NODE_ACTION_TYPE) return;
  var key = node[valueKey];
  keyMap.set(key, (keyMap.get(key) || 0) + 1);
};
var reduceNodes = function reduceNodes(_ref) {
  var nodes = _ref.nodes,
    valueKey = _ref.valueKey,
    childrenKey = _ref.childrenKey,
    expandedKeys = _ref.expandedKeys,
    _ref$flatNodes = _ref.flatNodes,
    flatNodes = _ref$flatNodes === void 0 ? [] : _ref$flatNodes,
    _ref$level = _ref.level,
    level = _ref$level === void 0 ? 0 : _ref$level,
    innerState = _ref.innerState;
  return nodes.reduce(function (preValue, node) {
    var _objectSpread2;
    var newNode = _objectSpread(_objectSpread({}, node), {}, (_objectSpread2 = {}, _objectSpread2[NODE_KEYS.NODE_LEVEL_KEY] = level, _objectSpread2));
    preValue.push(newNode);
    saveKeyCount(newNode, valueKey);
    if (expandedKeys.includes(newNode[valueKey])) {
      var innerNode = innerState[node[valueKey]];
      if (innerNode) {
        var _objectSpread3;
        preValue.push(_objectSpread(_objectSpread({}, innerNode), {}, (_objectSpread3 = {}, _objectSpread3[NODE_KEYS.NODE_LEVEL_KEY] = level + 1, _objectSpread3)));
        saveKeyCount(innerNode, valueKey);
      } else {
        preValue = reduceNodes({
          nodes: newNode[childrenKey] || [],
          valueKey: valueKey,
          childrenKey: childrenKey,
          expandedKeys: expandedKeys,
          flatNodes: preValue,
          level: level + 1,
          innerState: innerState
        });
      }
    }
    return preValue;
  }, flatNodes);
};
export var genFlatNodes = function genFlatNodes(_ref2) {
  var nodes = _ref2.nodes,
    valueKey = _ref2.valueKey,
    childrenKey = _ref2.childrenKey,
    expandedKeys = _ref2.expandedKeys,
    innerState = _ref2.innerState;
  keyMap.clear();
  return {
    flatNodes: reduceNodes({
      nodes: nodes,
      valueKey: valueKey,
      childrenKey: childrenKey,
      expandedKeys: expandedKeys,
      innerState: innerState
    }),
    duplicatedKeys: [].concat(keyMap.keys()).filter(function (key) {
      return keyMap.get(key) > 1;
    })
  };
};
export var isDisabled = function isDisabled(node, isNodeDisabled) {
  return node.isDisabled || isNodeDisabled(node);
};
export var isActionNode = function isActionNode(node) {
  return !!node[NODE_KEYS.NODE_ACTION_TYPE];
};
export var getSelectableKeys = function getSelectableKeys(_ref3) {
  var flatNodes = _ref3.flatNodes,
    valueKey = _ref3.valueKey,
    preNodeKey = _ref3.preNodeKey,
    curNodeKey = _ref3.curNodeKey,
    isNodeDisabled = _ref3.isNodeDisabled,
    isNodeSelectable = _ref3.isNodeSelectable,
    allowCrossParent = _ref3.allowCrossParent;
  var preNode = flatNodes.find(function (node) {
    return node[valueKey] === preNodeKey;
  });
  var curNode = flatNodes.find(function (node) {
    return node[valueKey] === curNodeKey;
  });
  if (!preNode || !curNode) return [curNodeKey];
  var level = curNode[NODE_KEYS.NODE_LEVEL_KEY];
  if (preNode[NODE_KEYS.NODE_LEVEL_KEY] !== level) return [curNodeKey];
  var _sort = [flatNodes.indexOf(preNode), flatNodes.indexOf(curNode)].sort(function (a, b) {
      return a - b;
    }),
    start = _sort[0],
    end = _sort[1];
  var nodesInRange = flatNodes.slice(start, end + 1);

  // To avoid select nodes under different parent node.
  if (!allowCrossParent && nodesInRange.some(function (node) {
    return node[NODE_KEYS.NODE_LEVEL_KEY] < level;
  })) return [curNodeKey];
  return nodesInRange.filter(function (node) {
    if (isActionNode(node) || isDisabled(node, isNodeDisabled) || !isNodeSelectable(node)) return false;
    if (node.isEditing || node[NODE_KEYS.NODE_LEVEL_KEY] !== level) return false;
    return true;
  }).map(function (node) {
    return node[valueKey];
  });
};
//# sourceMappingURL=treeHelper.js.map